/**
 * The from-scratch image mechanism.
 *
 * This product has no text-to-image endpoint: all three image models are dedicated `/edit`
 * (image-to-image) app IDs and the edge function rejects a request with no `image_data_url` with a
 * 400 before it ever checks the balance. Generating from a description alone therefore means
 * handing the edit model a neutral plate to paint over.
 *
 * That is not a workaround invented here — it is what the shipping AI scene-background feature
 * already does (`integration/generateSceneBackground.ts`). This module exists only because that
 * plate now has a second caller (text-only shot generation), and one copy is the whole point.
 */

/** 16:9 — the fallback when a project carries no parseable aspect ratio. */
export const DEFAULT_SEED_ASPECT = 16 / 9;

/** Neutral gray seed plate at the given width/height ratio. */
export function blankSeedDataUrl(aspect: number): string {
  const w = 1024;
  const h = Math.max(1, Math.round(w / aspect));
  const c = document.createElement('canvas');
  c.width = w;
  c.height = h;
  const ctx = c.getContext('2d');
  if (ctx) {
    ctx.fillStyle = '#8a8a8a';
    ctx.fillRect(0, 0, w, h);
  }
  return c.toDataURL('image/jpeg', 0.9);
}
